import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.find";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import pullAt from 'lodash/pullAt';
import get from 'lodash/get';
export default {
  name: 'CoreDtwinRuleEditConditions',
  props: {
    rule: {
      type: Object,
      required: true
    },
    // the indicies in order to get to the nested conditions
    conditionIndicies: {
      type: Array,
      required: true
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    // the states that are to be displayed / edited
    states: {
      type: Array,
      required: true
    },
    templateContext: {
      type: Boolean,
      required: false,
      default: false
    },
    isCreatedByTemplate: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function data() {
    return {
      logicalOperators: [{
        value: 'and',
        text: this.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.operations.and')
      }, {
        value: 'or',
        text: this.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.operations.or')
      }],
      comparisionOperators: [{
        value: 'eq',
        text: this.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.operations.eq')
      }, {
        value: 'not',
        text: this.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.operations.not')
      }, {
        value: 'lt',
        text: this.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.operations.lt'),
        type: 'numeric'
      }, {
        value: 'gt',
        text: this.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.operations.gt'),
        type: 'numeric'
      }, {
        value: 'lte',
        text: this.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.operations.lte'),
        type: 'numeric'
      }, {
        value: 'gte',
        text: this.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.operations.gte'),
        type: 'numeric'
      }] // javascript: null,

    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme'])), {}, {
    stateMetrics: function stateMetrics() {
      return get(this.rule, 'properties.stateMetrics', []);
    },
    conditions: function conditions() {
      if (this.conditionIndicies.length === 0) {
        return this.rule.properties.conditions;
      }

      var indicies = this.conditionIndicies.map(function (i) {
        return "items[".concat(i, "]");
      });
      return get(this.rule, "properties.conditions.".concat(indicies.join('.')));
    }
  }),
  methods: {
    emitChange: function emitChange() {
      this.$emit('conditions-changed');
    },
    addCondition: function addCondition() {
      this.conditions.items.push({
        key: '',
        compOperator: 'eq',
        compValue: 0
      });
      this.emitChange();
    },
    addOperator: function addOperator() {
      this.conditions.items.push({
        type: 'and',
        items: []
      });
      this.emitChange();
    },
    removeCondition: function removeCondition(index) {
      pullAt(this.conditions.items, [index]);
      this.conditions.items = cloneDeep(this.conditions.items);
      this.emitChange();
    },
    removeConditions: function removeConditions() {
      this.$emit('remove');
      this.emitChange();
    },
    comparitionOperatorsForState: function comparitionOperatorsForState(stateMetricKey) {
      var _this = this;

      if (stateMetricKey) {
        var stateMetric = get(this.rule, 'properties.stateMetrics', []).find(function (s) {
          return s.key === stateMetricKey;
        });

        if (stateMetric) {
          var state = this.states.find(function (s) {
            if (_this.templateContext) {
              return s.key === stateMetric.id;
            }

            if (_this.isCreatedByTemplate) {
              return s.key === stateMetric.key;
            }

            return s.id === stateMetric.stateId;
          });
          return this.comparisionOperators.filter(function (op) {
            return get(state, 'properties.valueType') === 'number' || !op.type || stateMetric.operation === 'since_last_update';
          });
        }
      }

      return this.comparisionOperators;
    }
  }
};